import "../edit.css";
import React, { useState } from "react";
import { Dropdown, MenuProps } from "antd";
import { Box } from "../wrapper";
import { SelectionItemProps, SelectionProps } from "./selection.props";
import { ChevronDownFill, ChevronUpFill } from "../../../assets";
import { Icon } from "../../icon";

export const Selection: React.FC<SelectionProps> = ({
  show: showInput,
  id,
  placeholder,
  className,
  selected,
  onSelect,
  items = [],
  error,
  disabled,
}) => {
  const initialSelected: SelectionItemProps = { key: "", text: "" };
  const [show, setShow] = useState<boolean>(false);

  const renderItems: MenuProps["items"] = items.map((item, index) => {
    return {
      label: (
        <button
          key={`edit-selection-${item.key}-${index}-${Math.random() * 100}`}
          className={`edit-selection-item ${
            selected.key === item.key || selected.text === item.key
              ? "selected"
              : ""
          }`}
          onClick={() =>
            onSelect(
              selected.key === item.key || selected.text === item.key
                ? initialSelected
                : item,
              id
            )
          }
        >
          <p>{item.text}</p>
        </button>
      ),
      key: item.key,
    };
  });

  return (
    <Box show={showInput} error={error} isDisabled={disabled ?? false}>
      <Dropdown
        menu={{ items: renderItems }}
        trigger={["click"]}
        rootClassName="edit-selection-overlay"
        onOpenChange={setShow}
        className={`edit-selection-dropdown edit-box ${className}`}
      >
        <button className="edit-box edit-selection-dropdown-box">
          <p
            className={`edit-box-placeholder ${
              selected.key.length > 0 ? "selected" : ""
            }`}
          >
            {selected.key.length > 0 ? selected.text : placeholder ?? ""}
          </p>

          <Icon
            icon={show ? ChevronUpFill : ChevronDownFill}
            alt={`${show ? "Hiden" : "Show"} options`}
          />
        </button>
      </Dropdown>
    </Box>
  );
};
